import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SectionHeading = styled(Typography)(({ theme }) => ({
  fontSize: 23,
  color: theme.palette.primary.main,
})) as typeof Typography;
